module.exports = __webpack_public_path__ + "static/media/customer-1.60a037e2.jpg";